import { changeRMActions } from "./action";

const initialState = {
  changeRMAData: null,
};

const saveChangeRMReducer = (state = initialState, action) => {
  switch (action.type) {
    case changeRMActions.SAVE_CHANGE_RM_DETAILS_SUCCESS:
      return {
        ...state,
        changeRMAData: action.payload,
      };
    case changeRMActions.SAVE_CHANGE_RM_DETAILS_ERROR:
      return {
        ...state,
        changeRMAData: [],
      };
    default:
      return state;
  }
};

export default saveChangeRMReducer;
